export default "__VITE_ASSET__DnJADy5n__"